(function($) {

    $.fn.loadingButton = function(options) {

        var settings = {
                loadingText: 'loading...',
                activeClass: 'loading'
            },
            isLoading = false,
            $el = this,
            txtFn = $el.is('input') ? 'val' : 'html',
            origText = $el[txtFn]();

        $.extend(settings, options);

        $el.on('click reset load', function() {
            setTimeout(toggle, 0); /* Defer to ensure form submit (click event) */
        });

        function toggle() {
            isLoading = !isLoading;
            if (isLoading) {
                $el[txtFn](settings.loadingText).addClass(settings.activeClass).attr('disabled', 'disabled');
            } else {
                $el[txtFn](origText).removeClass(settings.activeClass).removeAttr('disabled');
            }
        }

        this.destroy = function() {
            $el.remove();
        };

        return this;
    };

})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/loadingButton.js
 ** module id = 686
 ** module chunks = 0
 **/